<template>
  <v-app>
    <v-app-bar>
      <template v-slot:prepend>
        
      </template>
      <v-app-bar-title>AuroraFinder</v-app-bar-title>
      <template v-slot:append>
        <!-- **TODO Will need to update styling for mobile views -->
        <v-tabs
          v-model="tab"
        >
          <v-tab v-if="(getRawData(user)).status >= 5" to="/viewer">Watch</v-tab>
          <v-tab to="/about">About</v-tab>
          <v-tab to="/explore">Explore</v-tab>
          <v-tab to="/survey">Survey</v-tab>
          <v-tab to="/settings">Settings</v-tab>
          <v-tab v-if="!isLoggedIn" to="/login">Login</v-tab>
          <v-tab v-else @click="logout()">Logout</v-tab>
          <!-- <v-tab v-if="(getRawData(user)).status > 5" >show</v-tab>
          <v-tab >{{ (getRawData(user)).status }}</v-tab> -->
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main>
      <!-- <HelloWorld/> -->
        <!-- <messaging/> -->
        <!-- <v-btn @click="getTokenBTN" size="large" rounded="lg">Get Token</v-btn>

        <h3>Token: {{ token }}</h3>
        <h2>Message Title: {{ messageTitle }}</h2>
        <h3>Message Text: {{ messageText }}</h3>

        <v-divider></v-divider>
        <v-btn @click="testBTN" size="large" rounded="lg">Test Fetch</v-btn> -->

        <router-view></router-view>
        <v-container class="pt-0 align-center justify-center" max-width="1200">
          <v-card>
              <v-row class="pa-4 align-center justify-center" style="align-items: center;">
                <v-col class="align-center" cols="3">
                  <a href="https://www.nextgenenvironment.ca/" target="_blank">
                    <v-img src="nge_logo.png" />
                  </a>
                </v-col>
                <v-col class="align-center" cols="3">
                  <a href="https://www.churchillchamber.ca/" target="_blank">
                    <v-img src="ccc_logo.png" />
                  </a>
                </v-col>
              </v-row>
          </v-card>
        </v-container>


    </v-main>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import ImageCarousel from './components/ImageCarousel.vue';
import fb from './fb.js'
// import axios from 'axios';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useMainStore } from '@/store/store';
import { mapState } from 'pinia'
import { toRaw, ref, isReactive } from "vue";

export default {
  setup() {
    const store = useMainStore()

    const userAccessLevel = ref(0)

    return { 
      store,
      userAccessLevel,
    }
  },
  name: 'App',

  components: {
    // HelloWorld,
    // ImageCarousel,
  },

  data: () => ({
    token: '',
    messaging: null,
    messageTitle: '',
    messageText: '',
    tab: null,
    toRawUser: [],
    // userToken: localStorage.getItem('token') || '',
    // userData: localStorage.getItem('user') || {},
  }),
  computed: {
    ...mapState(useMainStore, {
      userToken: store => store.token,
      user: store => store.user,
      isLoggedIn: store => store.isLoggedIn,
    })
  },
  methods: {
    getTokenBTN(){
      if(fb){
      // console.log('fb exists!')
        this.messaging = getMessaging(fb)
        if(this.messaging){
          try {
            getToken(this.messaging, { vapidKey: "BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII",})
            .then((currentToken) => {
              if (currentToken) {
                // console.log("Token:", currentToken)
                this.token = currentToken
              } else {
                this.token = "No token available"
                // console.log("No token available")
              }
            })
          } catch(err) {
            // console.log('Error: ', err)
            this.token = err
          }
        }
      }
    },
    getRawData (data) {
      return isReactive(data) ? toRaw(data) : data
    },

    logout(){
      // console.log("Logging out")
      this.store.logout()
      
      // localStorage.removeItem('token')
      // localStorage.removeItem('user')
      // delete axios.defaults.headers.common['Authorization']

      // this.$router.go({ path: '/about' })
      this.$router.push({ path: '/about' })
      .then(() => {
        this.$router.go()
      })
      // this.$router.push({ path: 'about' })
    }
  },
  // async mounted() {
  mounted() {
    // console.log(this.$route.path)
    if(fb){
      // console.log('fb exists!')
      this.messaging = getMessaging(fb)
      if(this.messaging){
        // console.log('1')
        try {
          // getToken(this.messaging, { vapidKey: "BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII",})
          // .then((currentToken) => {
          //   if (currentToken) {
          //     console.log("Token:", currentToken)
          //     this.token = currentToken
          //   } else {
          //     console.log("No token available")
          //   }
          // })
          onMessage(this.messaging, (payload) => {
            this.messageTitle = payload.notification.title
            this.messageText = payload.notification.body
            // console.log('Message: ', payload)
          })
        } catch(err) {
          // console.log('Error: ', err)
          this.messageTitle = err
        }
      }
    }
    // if(messaging){
    //   console.log('messaging exists!')
      // try {
      //   messaging.getToken({ vapidKey: "BBaFCQ_NrGLHNo4ULInXKxl7kxWUyygfaxebeFYP2PaRRxYTMu17cPY-tKH2UMWdM3YIwe-5lVvrc0LK-a8BJII",})
      //   .then((currentToken) => {
      //     if (currentToken) {
      //       console.log("Token:", currentToken)
      //       this.token = currentToken
      //     } else {
      //       console.log("No token available")
      //     }
      //   })
      //   messaging.onMessage((payload) => {
      //     console.log('Message: ', payload)
      //   })
      // } catch(err) {
      //   console.log('Error: ', err)
      // }
    // }
  }
}
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
}
iframe{
    display:block; /* Add this */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
